import maskBg__asset from "@/assets/mask-group-4-1-1.png.asset.json";const maskBg = maskBg__asset.url;
import { norwoodClasses, quickQuoteUrl } from "@/lib/site-data";
import { rememberNorwood } from "@/components/forms/quick-quote-shared";

export function QuoteForm() {
  return (
    <section
      data-cta-location="form"
      className="py-10 md:py-14"
      style={{ backgroundColor: "rgba(0,0,0,0.64)" }}
    >
      <div className="mx-auto max-w-6xl px-4 lg:px-8">
        <div className="grid items-start gap-12 lg:grid-cols-2">
          <div className="bg-cover bg-center text-background" style={{ backgroundImage: `url(${maskBg})` }}>
            <h2 className="text-3xl font-extrabold leading-tight md:text-4xl">
              Get a Quote
              <br />
              <span className="text-background">& Save $1,000 on Your FUE Procedure.</span>
            </h2>
            <p className="mt-6 text-base leading-relaxed text-background/80">
              Exact cost depends on your level of hair loss. Tell us about your hair loss to get a
              quick quote. A full head of hair pays off for a lifetime.
            </p>
            <p className="mt-4 text-xs italic text-background/60">
              $1,000 off full price. Cannot be combined with any other discounts or offers.
            </p>
          </div>
          <div className="bg-background p-6 md:p-8">
            <h3 className="text-xl font-extrabold text-foreground">
              Which picture most closely <span className="text-foreground">resembles your hair loss?</span>
            </h3>
            <div className="mt-6 grid grid-cols-2 gap-3">
              {norwoodClasses.map((c) => (
                <a
                  key={c.label}
                  href={quickQuoteUrl}
                  onPointerDown={() => rememberNorwood(c.label)}
                  onClick={() => rememberNorwood(c.label)}
                  className="group flex flex-col items-center border-2 border-border bg-background p-3 transition hover:border-primary"
                >
                  <img loading="lazy" decoding="async" src={c.img} alt={`Norwood ${c.label} hair loss illustration`} width={248} height={248} className="h-24 w-auto object-contain" />
                  <span className="mt-2 text-sm font-bold text-foreground">{c.label}</span>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}